import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Field } from "react-final-form";
import { Form as SemanticForm, Icon, Popup } from "semantic-ui-react";
import {
  longDateFormatIdLegends,
  longTimeFormatIdLegends,
  shortDateFormatIdLegends,
  shortTimeFormatIdLegends,
  longDateFormatIdAdminLegends,
  longTimeFormatIdAdminLegends,
  shortDateFormatIdAdminLegends,
  shortTimeFormatIdAdminLegends
} from "../../config/legends/dateAndTimeFormats";
import { SelectInput } from "../../utils/components";
import { exists } from "../../utils/utils";

class DateAndTimeFormatPicker extends React.PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  static propTypes = {
    /** Available date formats. */
    dateFormats: PropTypes.array,
    /** Available time formats. */
    timeFormats: PropTypes.array,
    /** Disable fields? */
    disableAllFields: PropTypes.bool,
    /** Allow null? */
    allowNull: PropTypes.bool,
    /** Is there at least one fetch request loading? */
    isLoading: PropTypes.bool,
    /** Should display admin legends for fields? */
    displayAdminLegends: PropTypes.bool
  };

  static defaultProps = {
    disableAllFields: false,
    allowNull: false,
    isLoading: false,
    displayAdminLegends: false
  };

  currentDate = new Date();

  renderFieldWithInfoIcon = (key, name, label, infoContent, options = null) => (
    <SemanticForm.Field>
      <label style={{ display: "inline" }}>{label}</label>
      <Popup trigger={<Icon name="info circle" color="blue" style={{ float: "right" }} />}>
        {infoContent}
      </Popup>
      <Field
        key={key}
        name={name}
        aria-label={`${label} input`}
        component={SelectInput}
        options={options}
        clearable={this.props.allowNull}
        placeholder="Region default"
        disabled={this.props.disableAllFields}
        allowNull={this.props.allowNull}
        loading={this.props.isLoading}
      />
    </SemanticForm.Field>
  );

  formatOptionsList = options =>
    options.map(({ id, format }) => ({
      key: id,
      value: id,
      text: `${moment(this.currentDate).format(format)} - [${format}]`
    }));

  getShortDateFormatOptions = (options = this.props.dateFormats) =>
    exists(options)
      ? this.formatOptionsList(options.filter(({ type }) => type === "short").sort())
      : null;

  getLongDateFormatOptions = (options = this.props.dateFormats) =>
    exists(options)
      ? this.formatOptionsList(options.filter(({ type }) => type === "long").sort())
      : null;

  getShortTimeFormatOptions = (options = this.props.timeFormats) =>
    exists(options)
      ? this.formatOptionsList(options.filter(({ type }) => type === "short").sort())
      : null;

  getLongTimeFormatOptions = (options = this.props.timeFormats) =>
    exists(options)
      ? this.formatOptionsList(options.filter(({ type }) => type === "long").sort())
      : null;

  render() {
    const { displayAdminLegends } = this.props;
    return (
      <>
        {this.renderFieldWithInfoIcon(
          "short_date_format_id",
          "shortDateFormatId",
          displayAdminLegends
            ? shortDateFormatIdAdminLegends.label
            : shortDateFormatIdLegends.label,
          displayAdminLegends
            ? shortDateFormatIdAdminLegends.infoContent
            : shortDateFormatIdLegends.infoContent,
          this.getShortDateFormatOptions()
        )}
        {this.renderFieldWithInfoIcon(
          "long_date_format_id",
          "longDateFormatId",
          displayAdminLegends ? longDateFormatIdAdminLegends.label : longDateFormatIdLegends.label,
          displayAdminLegends
            ? longDateFormatIdAdminLegends.infoContent
            : longDateFormatIdLegends.infoContent,
          this.getLongDateFormatOptions()
        )}
        {this.renderFieldWithInfoIcon(
          "short_time_format_id",
          "shortTimeFormatId",
          displayAdminLegends
            ? shortTimeFormatIdAdminLegends.label
            : shortTimeFormatIdLegends.label,
          displayAdminLegends
            ? shortTimeFormatIdAdminLegends.infoContent
            : shortTimeFormatIdLegends.infoContent,
          this.getShortTimeFormatOptions()
        )}
        {this.renderFieldWithInfoIcon(
          "long_time_format_id",
          "longTimeFormatId",
          displayAdminLegends ? longTimeFormatIdAdminLegends.label : longTimeFormatIdLegends.label,
          displayAdminLegends
            ? longTimeFormatIdAdminLegends.infoContent
            : longTimeFormatIdLegends.infoContent,
          this.getLongTimeFormatOptions()
        )}
      </>
    );
  }
}

export default DateAndTimeFormatPicker;
